import axios, {AxiosResponse} from "axios";
import Customer from "@/model/Customer";
import CustomerType from "@/model/CustomerType";
import {PagedResult} from "@/service/PagedResult";

const PATH = "/customers";

export default {

    createCustomer(customer: Customer): Promise<AxiosResponse<Customer>> {
        const {customerType, ...data} = customer;
        return axios.post(`${PATH}`, data);
    },
    editCustomer(customer: Customer): Promise<AxiosResponse<Customer>> {
        const {customerType, ...data} = customer;
        return axios.put(`${PATH}/${customer.id}`, data);
    },
    // REWE is the only customer type, so it is not loaded from the backend.
    getCustomerTypes(): Promise<Array<CustomerType>> {
        return Promise.resolve([new CustomerType({id: 1, name: "REWE"})]);
    },
    getCustomerById(customerId: number): Promise<Customer> {
        return new Promise((resolve, reject) => {
            axios.get(`${PATH}/${customerId}`).then(response => {
                resolve(new Customer(response.data));
            }).catch(error => {
                reject(error);
            });
        });
    },
    findCustomer(search: string): Promise<Array<Customer>> {
        return new Promise((resolve, reject) => {
            axios.get(`${PATH}/search?term=${search}`).then(response => {
                resolve(Object.values(response.data));
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteCustomer(customerId: number): Promise<AxiosResponse<null>> {
        return axios.delete(`${PATH}/${customerId}`);
    },
    getOrders (customerId: number): Promise<AxiosResponse<PagedResult>> {
        return axios.get(`${PATH}/${customerId}/orders`);
    }
};
